import { Link } from "@inertiajs/react"
import { Card } from "@/components/ui/Card"
import { flagForCurrency } from "@/components/ui/Flag"
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/Table"
import { formatMoney } from "@/lib/money"
import { market_path } from "@/lib/routes"
import Delta from "./Delta"
import TargetBar from "./TargetBar"
import type { MarketSnapshot } from "./types"

/** One row of headline figures per market, each in the market's own currency. */
export default function MarketsTable({ markets }: { markets: MarketSnapshot[] }) {
  return (
    <Card className="px-5 pb-2 pt-4">
      <div className="text-sm font-semibold">Markets</div>
      <div className="mb-2 text-xs text-muted-foreground">Each market in its own currency. Click a market to open it.</div>
      <Table>
        <TableHeader>
          <TableRow className="hover:bg-transparent">
            <TableHead className="h-9 px-2 text-foreground">Market</TableHead>
            <TableHead className="h-9 px-2 text-right text-foreground">Revenue this month</TableHead>
            <TableHead className="h-9 px-2 text-foreground">vs same days last month</TableHead>
            <TableHead className="h-9 w-48 px-2 text-foreground">Plan progress</TableHead>
            <TableHead className="h-9 px-2 text-right text-foreground">Need buying</TableHead>
            <TableHead className="h-9 px-2 text-right text-foreground">Excess stock</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {markets.map((m) => {
            const Flag = flagForCurrency(m.currency)
            return (
              <TableRow key={m.id}>
                <TableCell className="px-2 py-3">
                  <Link href={market_path(m.slug)} className="inline-flex items-center gap-2 font-medium text-link underline-offset-4 hover:underline">
                    {Flag && <Flag size={16} />}
                    {m.name}
                  </Link>
                </TableCell>
                <TableCell className="px-2 py-3 text-right font-medium tabular-nums">{formatMoney(m.revenue_this_month, m.currency)}</TableCell>
                <TableCell className="px-2 py-3"><Delta pct={m.change_pct} /></TableCell>
                <TableCell className="px-2 py-3">
                  <TargetBar actual={m.plan.revenue ?? 0} target={m.plan.target ?? null} currency={m.currency} compact emptyText="No target" />
                </TableCell>
                <TableCell className={`px-2 py-3 text-right font-medium tabular-nums ${m.need_buying > 0 ? "text-warning" : ""}`}>{m.need_buying}</TableCell>
                <TableCell className="px-2 py-3 text-right tabular-nums">{m.excess.total}</TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </Card>
  )
}
